import { inject, autoinject, LogManager, bindable } from 'aurelia-framework';
import { DialogController } from 'aurelia-dialog';
import { Logger } from 'aurelia-logging';
import { Endpoint, Rest } from 'aurelia-api';
import { ControllerValidateResult, ValidationController, ValidationControllerFactory } from 'aurelia-validation';
import { BootstrapFormRenderer } from '../../services/bootstrap-form-renderer';
import { Helpers } from '../../services/helpers';
import { SubAssignmentViewModel } from '../../models/subassignmentview-model';
import { SubAssignmentEditViewModel } from '../../models/subassignmenteditview-model';
import { AssignmentViewModel } from '../../models/assignmentview-model';

@autoinject
export class SubAssignmentsModalUpdate {
    @bindable id: number = 0;
    model: SubAssignmentEditViewModel = null;
    private logger: Logger = LogManager.getLogger('SUBASSIGNMENTMODALUPDATE');
    private validationController: ValidationController | null = null;
    private saveDisabled: boolean = false;

    private assignments: AssignmentViewModel[] = [];

    constructor(@inject(Endpoint.of('api')) private api: Rest,
        private validationControllerFactory: ValidationControllerFactory,
        private dialogController: DialogController) {
        this.validationController = validationControllerFactory.createForCurrentScope();

        this.validationController.addRenderer(new BootstrapFormRenderer());
    }

    async activate(params: any) {
        this.logger.debug('activate');
        this.id = params.subAssignmentId;

        await this.getModel();
        await this.getAssignments();
    }

    async getModel() {
        this.logger.debug('getModel');

        await this.api.find('/SubAssignment/GetById', this.id)
            .then(async (data: SubAssignmentViewModel) => {
                this.logger.debug('Success getModel: ', data);
                this.model = new SubAssignmentViewModel(data);
            }).catch(async (err) => {
                this.logger.debug('Error getModel: ', err);
                await Helpers.ParseValidationError(err, this.validationController, this.model);
            });
    }

    async getAssignments() {
        this.logger.debug('getAssignments');

        await this.api.find('/Assignment/GetAll_Sorted')
            .then((data: Array<AssignmentViewModel>) => {
                this.assignments = data;
                this.logger.debug('Success getAssignments: ', data);
            }).catch(async (err) => {
                this.logger.debug('Error getAssignments: ', await err.json());
                await Helpers.ParseValidationError(err, this.validationController, this.model);
            });
    }

    async save() {
        this.logger.debug('save');
        this.saveDisabled = true;

        const validation: ControllerValidateResult = await this.validationController.validate();

        if (validation) {
            await this.api.update('/SubAssignment/Update', this.id, this.model)
                .then((data: SubAssignmentEditViewModel) => {
                    this.logger.debug('Success save: ' + data);
                    this.saveDisabled = false;
                    this.dialogController.ok(data);
                }).catch(async (err) => {
                    this.saveDisabled = false;
                    this.logger.debug('Error save: ', err);
                    await Helpers.ParseValidationError(err, this.validationController, this.model);
                });
        }
    }

    cancel() {
        this.dialogController.cancel();
    }
}